/*
  example:
    import { listLeases } from '@/services/Lease/Lease/List';

    const { list, successful, message } = await listLeases ({
      params: {
        unitID
      } 
    });
    if (!successful) {
      console.error (message);
      return;
    }
*/
//
import _get from 'lodash/get'
//
import kms from '@/services/kms'
//
export async function listLeases({ params, kms: kms_ = kms } = {}) {
  const message = 'The lease list could not be retrieved.'

  try {
    const result = await kms_.get(`/Lease/Lease/List`, {
      params
    })

    let list = _get(result, 'results', [])
    if (!Array.isArray(list)) {
      list = []
    }

    return {
      successful: true,
      message: '',
      list
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    successful: false,
    message,
    list: []
  }
}

///////
